(function() {
    'use strict';
    

a3_cabin_reports.config(httpProviderConfig)

    /**
    * @memberof CabinReports
    * @ngdoc config
    * @name httpProviderConfig
    * @description 
    *  Register interceptors and modify headers
    * @ngInject
    */
function httpProviderConfig($httpProvider) {
	$httpProvider.defaults.useXDomain = true;
	delete $httpProvider.defaults.headers.common['X-Requested-With'];

	$httpProvider.interceptors.push('http401interceptor');
    $httpProvider.interceptors.push('httpCrewTokenInterceptor');
    $httpProvider.interceptors.push('httpHeaderInterceptor');
}

    
})();